import styled from '@emotion/styled'

import theme from 'styles/theme'

export const VideoButton = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 60px;
  height: 60px;
  background: ${theme.token.var('colors.light')};
  border-radius: 16px;
`
